"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const scale_1 = require("../../utils/scale");
const FONT_FAMILY = {
    w3: "Hiragino Kaku Gothic Pro W3",
    w6: "Hiragino Kaku Gothic Pro W6",
};
const CustomText = (props) => {
    const { children, style, font, size, color, flex, weight = '300' } = props;
    let textStyle = {};
    return (react_1.default.createElement(react_native_1.Text, { allowFontScaling: false, onPress: props.onPress, ...props, style: [
            styles.text,
            style,
            textStyle,
            size && { fontSize: (0, scale_1.moderateScale)(size) },
            color && { color },
            flex && { flex },
            weight && {
                fontFamily: "Hiragino Kaku Gothic ProN",
                fontWeight: weight === '600' ? '700' : weight,
            },
        ] }, children));
};
const styles = react_native_1.StyleSheet.create({
    text: {
        includeFontPadding: false,
        padding: 0,
        fontSize: (0, scale_1.moderateScale)(20),
        color: "#292A33",
    },
});
exports.default = CustomText;
